import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router';
import { myContext } from '../App';

export function ContactUs() {

    const [showSubmittedMessage, setShowSubmittedMessage] = useState(true);

    // use useNavigate hook to redirect the user to any other page
    const navigate = useNavigate();
    // Import and use the useContext hook to access the data from app.jsx
    const footerContext = useContext(myContext);

    const navigateTo = (path) => {
        footerContext.setRender(!footerContext.render);
        navigate(path)
    }


    const onContactUsClick = async () => {
        setShowSubmittedMessage(false);
    }

    return <div>
        {/* gradient banner starts  */}
        <div className="text-banner primary-gradient-bg d-flex align-items-center justify-content-center ">
            <h1 className="font-60 text-center">GET CONNECTED</h1>
        </div>
        {/* gradient banner ends  */}
        {/* contact form starts here  */}
        <div className="container mb-5 pb-3">
            <div className="row justify-content-center px-4 px-md-0">
                <h2 className="text-center mt-5 pt-4 mb-5 text-uppercase grey-color-v1">Our team is here to help - Contact us today!
                </h2>
                <a type="submit" href="mailto:contact@cfs.canon.com?subject=Canon Financial Services Website Inquiry" className={`header-button px-5 text-uppercase btn-sm w-auto  text-decoration-none`} onClick={() => { onContactUsClick() }}>Contact Us</a>
                <div className="custom-form-text info-msg-margin text-center" hidden={showSubmittedMessage}>
                    Thanks for your interest! If your default email application did not open, please email us at <a href="mailto:contact@cfs.canon.com?subject=Customer Service Website Inquiry
                ">contact@cfs.canon.com.</a>
                </div>
            </div>
        </div>

        {/* contact form ends here  */}
        {/* recognized banner starts here */}
        <div className="grey-bg w-100">
            <div className="container">
                <div className="row justify-content-center align-items-center">
                    <div className="col-md-3">
                        <div className="d-flex justify-content-center">
                            <a href="https://www.monitordaily.com/monitor100/2023-monitor-100/" target="_blank"><img src="./images/monitor-badge.svg" alt="monitor-badge" className="mb-2 pb-1" /></a>
                        </div>
                    </div>
                    <div className="col-md-5 my-5 my-lg-0 ms-md-5 ms-lg-0  text-center text-md-start text-lg-start">
                        <h3 className="mb-4 pb-2 grey-color-v1
">Proud to be recognized</h3>
                        <p className="font-16">Offering a variety of financing plans to help customers acquire the equipment, systems, and
                            software needed to drive future innovation and business profits.</p>
                    </div>
                </div>
            </div>
        </div>
        {/* recognized banner ends here */}

        {/* extra help starts here */}
        <div className="container mb-4 pb-3">
            <div className="row justify-content-center px-4 px-md-0">
                <h2 className="text-center mb-5 pb-5 text-uppercase grey-color-v1 mt-5">Need Some Extra Help? Contact Customer Support!
                </h2>
                <div className="mb-4 col-xl-10">
                    <div className="row align-items-center">
                        <div className="mb-4 col-lg-3">
                            <div className="d-flex align-items-center gap-3 my-4 my-lg-0">
                                <span><img src="./images/home-icon.svg" alt="home-icon" /></span>
                                <span className="font-16 font-regular">158 Gaither Drive,
                                    <span className='d-block'>Mount Laurel, NJ 08054</span></span>
                            </div>
                        </div>
                        <div className="mb-4 d-flex justify-content-lg-center col-lg-3">
                            <div className="d-flex align-items-center gap-3 my-4 my-lg-0">
                                <span><img src="./images/mail.svg" alt="home-icon" /></span>
                                <span className="font-16 font-regular"><a href="mailto:customer@cfs.canon.com?subject=Customer Service Website Inquiry" className="text-decoration-none primary-color">customer@cfs.canon.com</a></span>
                            </div>
                        </div>
                        <div className="mb-4 d-flex justify-content-lg-center col-lg-3">
                            <div className="d-flex align-items-center gap-3 my-4 my-lg-0">
                                <span><img src="./images/call-icon.svg" alt="home-icon" /></span>
                                <span className="font-16 font-regular"><a href="tel:(800) 220-0330" className="text-decoration-none primary-color">(800) 220-0330</a></span>
                            </div>
                        </div>
                        <div className="mb-4 col-lg-3">
                            <div className="d-flex align-items-center gap-3 my-4 my-lg-0">
                                <span><img src="./images/faq-icon.svg" alt="home-icon" /></span>
                                <span className="font-16 font-regular"><a onClick={() => { navigateTo("/Faq") }} className="text-decoration-none primary-color cursor-pointer">Frequently Asked Questions</a></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {/* extra help ends here */}
        {/* gradient band starts  */}
        <div className="w-100 primary-gradient-bg p-3 contact-cta-sm">
            <p className="font-18 font-regular secondary-color text-center mb-0">
                <span className="font-bold mb-md-0">GO GREEN with Canon.</span> <span>Choose Paperless Billing and Pay Online
                    Today!</span>
                <a className="primary-outline-btn font-bold font-16 text-uppercase ms-4 mt-4 mt-lg-0 py-2 px-3 text-decoration-none" href="https://mycfs.cfs.canon.com/" target='_blank'>
                    Make a Payment
                </a>
            </p>
        </div>
        {/* gradient band ends  */}
    </div>
}